// FilterList
import React from 'react';
import PropTypes from 'prop-types';

const FilterSelectionListItem = ({ filterClick, option, filters }) => (
  <li role="menuitem" key={option.name.toLowerCase().replace(/[\s]+/g, '-')} className={`filter-selection-item ${option.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-item`}>
    <input className="filter-checkbox" id={option.name.toLowerCase().replace(/[\s]+/g, '-')} name={option.inputName} type={option.type} value={option.value} onChange={() => filterClick(option)} checked={(option.isChecked === true ? 'checked' : '')} />
    <label className="filter-label" htmlFor={option.name.toLowerCase().replace(/[\s]+/g, '-')}>
      {option.image !== '' && option.image !== undefined
        ? <img className="option-image" src={`${filters.productRatingImagePath}${option.image}`} alt={option.name} />
        : ''}
      {option.name}
    </label>
  </li>
);

FilterSelectionListItem.propTypes = {
  filterClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    inputName: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
  }),
  filters: PropTypes.shape({
    productRatingImagePath: PropTypes.string,
  }),
};

const FilterSelectionList = props => (
  <ul role="menu" id={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`} className={`list-unstyled filter-selection-list ${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`}>
    {props.filter.options.map(option => (
      <FilterSelectionListItem key={option.name.toLowerCase().replace(/[\s]+/g, '-')} {...Object.assign({}, props, { option })} />
    ))}
  </ul>
);

FilterSelectionList.propTypes = {
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(PropTypes.object),
  }),
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

const FilterListItem = props => (
  <li role="menuitem" className={`filter-list-item ${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-filter-list-item`}>
    <button
      type="button"
      className={`filter-button ${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-button dropdown-toggle btn-transparent ${(props.filter.active === true ? 'active' : '')}`}
      aria-expanded={props.filter.active}
      aria-controls={`${props.filter.name.toLowerCase().replace(/[\s]+/g, '-')}-selection-list`}
      onClick={event => props.buttonClick(event, props.filter.name)}
    >
      {props.filter.name}
    </button>
    <FilterSelectionList {...props} />
  </li>
);

FilterListItem.propTypes = {
  buttonClick: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
  }),
};

const FilterList = props => (
  <ul role="menu" className="list-unstyled filter-list">
    {Object.keys(props.filters).filter(key => typeof props.filters[key] !== 'string').sort((keyA, keyB) => props.filters[keyA].order - props.filters[keyB].order).map(key => (
      <FilterListItem key={key} order={props.filters[key].order} {...props} filter={props.filters[key]} />
    ))}
  </ul>
);

FilterList.propTypes = {
  filters: PropTypes.shape(PropTypes.object),
  filter: PropTypes.shape({
    order: PropTypes.number.isRequired,
  }),
};

export {
  FilterList,
  FilterListItem,
  FilterSelectionList,
  FilterSelectionListItem,
};
